<script setup>
import BaseModal from "@/components/global/modals/BaseModal.vue";
import DefaultButton from "@/components/onsiteEditor/components/buttons/DefaultButton.vue";

const emit = defineEmits(['close', 'confirm']);
</script>

<template>
  <BaseModal @close="emit('close')">
    <template #heading>
      Before You Start Your SEO With the Onsite Optimizer
    </template>
    <div class="tw-flex tw-max-w-[700px] tw-flex-col tw-justify-center tw-gap-2 tw-text-slate-200">
      <div class="tw-text-center">
        Please be aware that any SEO changes made through the Onsite Optimizer will not remain active if a
        website is removed from your account via Vendasta.
      </div>
      <div class="tw-text-center">
        This means that all implemented SEO enhancements will be reverted once the website is no longer managed through the platform.
      </div>

      <div class="tw-text-center">
        Please acknowledge you understand this by clicking ""Confirm"" below."
      </div>
    </div>
    <template #footer>
      <div class="tw-flex tw-w-full tw-justify-center">
        <div class="tw-w-1/3">
          <DefaultButton
            class="tw-mt-5"
            @click="emit('confirm')"
          >
            Confirm
          </DefaultButton>
        </div>
      </div>
    </template>
  </BaseModal>
</template>
